import React, { Fragment, useEffect } from "react";

import NewNavbar from "../../new-components/NewNavbar";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewEventsList from "../../new-components/NewEventsList";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewBackButton from "../../new-components/NewBackButton";

const EventsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />

      <NewEventsList />

      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default EventsPage;
